import axios from 'axios'
import {
  get_agencies,
  get_document,
  get_fpool_general,
  get_fpool_special,
  get_parameters,
  get_products,
  get_quotedoc,
  get_residence_municipalities,
  get_vehicle_brands,
  get_vehicle_models,
  get_vehicle_versions,
  post_otherdoc,
  post_otherdocs,
  post_quote,
  post_quotedoc,
  post_support_agency,
  product_client,
} from 'src/axios'
import {
  agency_t,
  ax_get_agencies,
  ax_get_fpool_general,
  ax_get_fpool_special,
  ax_get_parameters,
  ax_get_products,
  ax_get_quotedoc,
  ax_get_residence_municipalities,
  ax_get_vehicle_informations,
  ax_get_vehicle_models,
  ax_get_vehicle_versions,
  ax_post_otherdoc,
  ax_post_otherdocs,
  ax_post_quote,
  ax_post_quotedoc,
  ax_post_support_agency,
  fitem_rd,
  fpool_special,
  municipality_t,
  otherdoc_list_t,
  otherdoc_t,
  parameter_t,
  product_t,
  quote_t,
  quotedoc_t,
  response_t,
  saga_act,
  vehicle_brand_t,
  vehicle_model_t,
  vehicle_version_t,
} from 'src/types'

import { do_request } from './base.http'

/**
 * Resolve fpool general
 */
export async function http_resolve_fpool_general({
  args,
  type,
}: saga_act<ax_get_fpool_general>): Promise<response_t<fitem_rd[]>> {
  return do_request<fitem_rd[]>({
    client: product_client,
    request: get_fpool_general(args),
    saga_type: type,
  })
}

/**
 * Resolve fpool special
 */
export async function http_resolve_fpool_special({
  args,
  type,
}: saga_act<ax_get_fpool_special>): Promise<response_t<fpool_special[]>> {
  return do_request<fpool_special[]>({
    client: product_client,
    request: get_fpool_special(args),
    saga_type: type,
  })
}

/**
 * Resolve products
 */
export async function http_resolve_products({
  args,
  type,
}: saga_act<ax_get_products>): Promise<response_t<product_t[]>> {
  return do_request<product_t[]>({
    client: product_client,
    request: get_products(args),
    child: 'products',
    saga_type: type,
  })
}

/**
 * Resolve vehicle brands
 */
export async function http_resolve_vehicle_brands({
  args,
  type,
}: saga_act<ax_get_vehicle_informations>): Promise<response_t<vehicle_brand_t[]>> {
  return do_request<vehicle_brand_t[]>({
    client: product_client,
    request: get_vehicle_brands(args),
    child: 'brands',
    saga_type: type,
  })
}

/**
 * Resolve vehicle models
 */
export async function http_resolve_vehicle_models({
  type,
  args,
}: saga_act<ax_get_vehicle_models>): Promise<response_t<vehicle_model_t[]>> {
  return do_request<vehicle_model_t[]>({
    client: product_client,
    request: get_vehicle_models(args),
    child: 'models',
    saga_type: type,
  })
}

/**
 * Resolve vehicle versions
 */
export async function http_resolve_vehicle_versions({
  type,
  args,
}: saga_act<ax_get_vehicle_versions>): Promise<response_t<vehicle_version_t[]>> {
  return do_request<vehicle_version_t[]>({
    client: product_client,
    request: get_vehicle_versions(args),
    child: 'versions',
    saga_type: type,
  })
}

/**
 * Resolve residence municipalities - TODO
 */
export async function http_resolve_residence_municipalities({
  type,
  args,
}: saga_act<ax_get_residence_municipalities>): Promise<response_t<municipality_t[]>> {
  return do_request<municipality_t[]>({
    client: axios.create({
      responseType: 'json',
      baseURL: 'https://www.gruppoitas.it',
    }),
    request: get_residence_municipalities(args),
    child: 'results',
    saga_type: type,
  })
}

/**
 * Require quote
 */
export async function http_require_quote({
  args,
  type,
}: saga_act<ax_post_quote>): Promise<response_t<quote_t[]>> {
  return do_request<quote_t[]>({
    client: product_client,
    request: post_quote(args),
    saga_type: type,
  })
}

/**
 * Resolve agencies
 */
export async function http_resolve_agencies({
  args,
  type,
}: saga_act<ax_get_agencies>): Promise<response_t<agency_t[]>> {
  return do_request<agency_t[]>({
    client: product_client,
    request: get_agencies(args),
    saga_type: type,
    child: 'locations',
  })
}

/**
 * Send support agency
 */
export async function http_send_support_agency({
  args,
  type,
}: saga_act<ax_post_support_agency>): Promise<response_t<string>> {
  return do_request<string>({
    client: product_client,
    request: post_support_agency(args),
    saga_type: type,
  })
}

/**
 * Resolve quote document
 */
export async function http_resolve_quotedoc({
  args,
  type,
}: saga_act<ax_get_quotedoc>): Promise<response_t<quotedoc_t>> {
  return do_request<quotedoc_t>({
    client: product_client,
    request: get_quotedoc(args),
    saga_type: type,
  })
}

/**
 * Send quote document
 */
export async function http_send_quotedoc({
  args,
  type,
}: saga_act<ax_post_quotedoc>): Promise<response_t<string>> {
  return do_request<string>({
    client: product_client,
    request: post_quotedoc(args),
    saga_type: type,
  })
}

/**
 * Resolve other documents
 */
export async function http_resolve_otherdocs({
  args,
  type,
}: saga_act<ax_post_otherdocs>): Promise<response_t<otherdoc_list_t[]>> {
  return do_request<otherdoc_list_t[]>({
    client: product_client,
    request: post_otherdocs(args),
    saga_type: type,
    child: 'elencoStampe',
  })
}

/**
 * Resolve other document
 */
export async function http_resolve_otherdoc({
  args,
  type,
}: saga_act<ax_post_otherdoc>): Promise<response_t<otherdoc_t>> {
  return do_request<otherdoc_t>({
    client: product_client,
    request: post_otherdoc(args),
    saga_type: type,
  })
}

/**
 * Resolve parameters
 */
export async function http_resolve_parameters({
  args,
  type,
}: saga_act<ax_get_parameters>): Promise<response_t<parameter_t[]>> {
  return do_request<parameter_t[]>({
    client: product_client,
    request: get_parameters(args),
    saga_type: type,
  })
}

/**
 * Resolve Generic document
 */
export async function http_resolve_document({
  args,
  type,
}: saga_act<parameter_t>): Promise<response_t<parameter_t>> {
  console.log(JSON.stringify(args?.id_parametro))
  return do_request<parameter_t>({
    client: product_client,
    request: get_document(args?.id_parametro || ''),
    saga_type: type,
  })
}
